import type { AppLink } from '../lib/appLinks';
import { EXTERNAL_LINK_PROPS } from '../lib/appLinks';

interface AppLinkGridProps {
  apps: AppLink[];
  columns?: 'auto' | 2 | 3 | 4;
}

function AppLinkGrid({ apps, columns = 'auto' }: AppLinkGridProps) {
  const gridClass =
    columns === 'auto'
      ? 'grid grid-cols-1 gap-1.5 sm:grid-cols-2'
      : columns === 2
        ? 'grid grid-cols-1 gap-1.5 sm:grid-cols-2'
        : columns === 3
          ? 'grid grid-cols-1 gap-1.5 sm:grid-cols-2 lg:grid-cols-3'
          : 'grid grid-cols-1 gap-1.5 sm:grid-cols-2 lg:grid-cols-3';

  return (
    <div className={gridClass}>
      {apps.map((app) => (
        <a
          key={app.id}
          href={app.url}
          {...EXTERNAL_LINK_PROPS}
          className="group flex min-w-0 items-center gap-2.5 rounded-lg border border-zt-border bg-zt-bg px-3 py-2 text-left transition-colors hover:border-zt-primary hover:bg-zt-elevated"
          title={app.description}
        >
          <app.icon
            size={18}
            className="shrink-0 text-zt-muted transition-colors group-hover:text-zt-primary"
          />
          <span className="min-w-0 truncate text-xs font-medium text-slate-200 group-hover:text-zt-primary">
            {app.name}
          </span>
        </a>
      ))}
    </div>
  );
}

export default AppLinkGrid;
